import React, { useEffect, useContext, useState } from 'react'
import FullScreenPopup from '@/product/components/organisms/FullScreenPopup'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import Loaders from '@/product/components/molecules/Loaders'
import { mapData } from '@/product/common/components'
import { LinearProgress } from '@mui/material'
import { useFormik } from 'formik'
import AgencyContext from '@/product/context/agency/agencyContext'
import CommonContext from '@/product/context/common/commonContext'
import * as Yup from 'yup'
import { Button, Dialog } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import Slide from '@mui/material/Slide'
import IconButton from '@mui/material/IconButton'
import CustomDialog from '@/product/components/organisms/Dialog'
import SettingContext from '@/product/context/setting/settingContext'
import CustomTable from '@/product/components/molecules/CustomTable'

let randomVariable = Math.random()

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />
})

const AgencyForm = (props) => {
    const agencyContext = useContext(AgencyContext)
    const commonContext = useContext(CommonContext)
    const settingcontext = useContext(SettingContext)

    const {
        all_agency,
        agencyAction,
        getSingleAgency,
        single_agency,
        changeAgencyStatus,
        responseStatus: responseStatusAgency,
        clearResponse: clearResponseUser,
    } = agencyContext
    const { updateConfigColumn } = settingcontext
    const { USStates, allCountries, allStates, allCounties, getAllCounties } =
        commonContext
    const [isLoading, setIsLoading] = useState(false)
    const [agencyAddress, setAgencyAddress] = useState([])
    const [reload, setReload] = useState(false)
    const [addressDisable, setAddressDisable] = useState(false)
    const [agencyPhone, setAgencyPhone] = useState([])
    const [addressPopup, setAddressPopup] = useState(false)
    const [phonePopup, setPhonePopup] = useState(false)
    const [paymentMethod, setPaymentMethod] = useState([])
    const [paymentModal, setPaymentModal] = useState(false)
    const [taxTable, setAllTaxTable] = useState([])
    const [allCountiesDropdown, setAllCountiesDropdown] = useState([])
    const [allCitiesDropdown, setAllCitiesDropdown] = useState([])

    const phoneTypes = [
        { show: 'Main Office', value: 'main_office' },
        { show: 'Sub Office', value: 'sub_office' },
    ]
    const [data, setData] = useState(props.data)

    let agencyType = single_agency?.record.agency_type

    useEffect(() => {
        setData(props.data)
    }, [props?.data])

    useEffect(() => {
        getAllCounties({
            filters: { active: { field: 'dc.active', type: 'in', value: '1' } },
        })
    }, [])

    const groupAndRemoveDuplicates = (data, fieldName) => {
        const uniqueValues = []
        const filteredData = data.filter((entry) => {
            if (!uniqueValues.includes(entry[fieldName])) {
                uniqueValues.push(entry[fieldName])
                return true
            }
            return false
        })

        filteredData.sort((a, b) => {
            return a[fieldName].localeCompare(b[fieldName])
        })

        return filteredData
    }

    useEffect(() => {
        if (allCounties?.records?.length) {
            setAllTaxTable(
                allCounties.records.length ? allCounties.records : []
            )
            setAllCountiesDropdown(
                groupAndRemoveDuplicates(allCounties.records, 'county')
            )
            setAllCitiesDropdown(
                groupAndRemoveDuplicates(allCounties.records, 'city')
            )
        }
    }, [allCounties])

    const projectType = [
        { show: '1', value: '1' },
        { show: '2', value: '2' },
    ]

    const srcType = [
        { show: '1', value: '1' },
        { show: '2', value: '2' },
    ]

    const acceptedDecimalFields = [
        'state_tax',
        'county_tax',
        'city_tax',
        'county_transit_sales_use_tax',
        'metro_transportation_tax',
        'metro_sale_use_for_housing',
        'transit_tax',
        'vehicle_tax',
        'auto_excise_tax',
    ]

    const [initialValues, setInitialValues] = useState({
        id: 0,
        agency_name: '',
        agency_short_name: '',
        agency_number: '',
        parent_agency_id: '',
        agency_type: 1,
        // page: 1,
        // limit: 1,
        order: '',
        orderby: '',
        fetchTables: ['agencies_address', 'agencies_phone', 'agencies_payment'],
        filters: {
            id: {
                value: '',
                type: 'in',
                field: 'ag.id',
            },
            agency_name: {
                value: '',
                type: 'like',
                field: 'ag.agency_name',
            },
            agency_number: {
                value: '',
                type: 'like',
                field: 'ag.agency_number',
            },
        },
    })

    const resetFrom = () => {
        formik.setFieldValue('id', 0)
        formik.setFieldValue('agency_name', '')
        formik.setFieldValue('agency_short_name', '')
        formik.setFieldValue('agency_number', '')
        formik.setFieldValue('parent_agency_id', '')
        formik.setFieldValue('agency_type', 1)
    }

    const validationArray = Yup.object({
        agency_name: Yup.string()
            .min(2, 'Mininum 2 characters')
            .required('Required!'),
        agency_short_name: Yup.string()
            .nullable()
            .min(2, 'Mininum 2 characters')
            .max(15, 'Maximum 5 characters'),
        // .required('Required!'),
        parent_agency_id: Yup.string()
            .trim()
            .matches(/^[0-9- +()]*$/g, 'Only numbers are allowed')
            .nullable(),
        agency_type: Yup.number().required('Required'),
    })

    const formik = useFormik({
        initialValues: initialValues,
        // enableReinitialize: true,
        validationSchema: validationArray,
        onSubmit: (values) => {
            let actionValues = { ...values, table: 'agencies' }
            randomVariable = Math.random()
            agencyAction(actionValues, randomVariable)
            setIsLoading(true)
        },
    })

    useEffect(() => {
        if (props.agencyStatus === 'new' && props.agencyId) {
            getSingleAgency(
                {
                    id: props.agencyId,
                    fetchTables: [
                        'agencies_address',
                        'agencies_phone',
                        'agencies_payment',
                    ],
                },
                randomVariable
            )
        } else {
            resetFrom()
            setIsLoading(false)
        }
    }, [props?.agencyStatus])

    useEffect(() => {
        if (props.agencyId) {
            setIsLoading(true)
            getSingleAgency(
                {
                    id: props.agencyId,
                    fetchTables: [
                        'agencies_address',
                        'agencies_phone',
                        'agencies_payment',
                    ],
                },
                randomVariable
            )
        }
    }, [props.agencyId])

    useEffect(() => {
        setIsLoading(false)
        if (single_agency?.record && !props.data && props.agencyId) {
            const agency = single_agency.record
            // setInitialValues({
            //     id: agency?.id,
            //     agency_name: agency?.agency_name || '',
            //     agency_short_name: agency?.agency_short_name || '',
            //     agency_number: agency?.agency_number || '',
            //     parent_agency_id: agency?.parent_agency_id || '',
            //     agency_type: agency?.agency_type || 1,
            // })
            formik.values.id = agency?.id
            formik.values.agency_name = agency?.agency_name || ''
            formik.values.agency_short_name = agency?.agency_short_name || ''
            formik.values.agency_number = agency?.agency_number || ''
            formik.values.parent_agency_id = agency?.parent_agency_id || ''
            formik.values.agency_type = agency?.agency_type || 1

            agency?.agencies_address?.length
                ? setAgencyAddress(agency?.agencies_address)
                : setAgencyAddress([])
            agency?.agencies_phone?.length
                ? setAgencyPhone(agency?.agencies_phone)
                : setAgencyPhone([])
            agency?.agencies_payment?.length
                ? setPaymentMethod(agency?.agencies_payment)
                : setPaymentMethod([])
            setIsLoading(false)
        } else if (props.agencyStatus == 'new' && props.agencyId) {
            const agency = single_agency.record
            setInitialValues({
                id: agency?.id,
                agency_name: agency?.agency_name || '',
                agency_short_name: agency?.agency_short_name || '',
                agency_number: agency?.agency_number || '',
                parent_agency_id: agency?.parent_agency_id || '',
                agency_type: agency?.agency_type || 1,
            })
            agency?.agencies_address?.length
                ? setAgencyAddress(agency?.agencies_address)
                : setAgencyAddress([])
            agency?.agencies_phone?.length
                ? setAgencyPhone(agency?.agencies_phone)
                : setAgencyPhone([])
            agency?.agencies_payment?.length
                ? setPaymentMethod(agency?.agencies_payment)
                : setPaymentMethod([])
            setIsLoading(false)
        } else {
            resetFrom()
        }
    }, [single_agency])

    const resetFormikValues = (formik) => {
        formik?.setValues(formik?.initialValues)
        formik?.setTouched({}, false)
    }

    useEffect(() => {
        if (responseStatusAgency?.status === 'success') {
            if (
                responseStatusAgency?.from === randomVariable &&
                props.agencyStatus == 'edit'
            ) {
                setIsLoading(false)

                if (responseStatusAgency.data.data.agency_id) {
                    formik.values.id = responseStatusAgency.data.data.agency_id
                    phoneFormik.values.agency_id =
                        responseStatusAgency.data.data.agency_id
                    addressFormik.values.agency_id =
                        responseStatusAgency.data.data.agency_id

                    phoneFormik.values.agency_id =
                        responseStatusAgency.data.data.agency_id

                    paymentFormik.values.agency_id =
                        responseStatusAgency.data.data.agency_id

                    setReload(!reload)
                }

                setData({
                    ...data,
                    id: responseStatusAgency.data.data.agency_id,
                    status: 'edit',
                })
                randomVariable = Math.random()

                getSingleAgency(
                    {
                        id: responseStatusAgency.data.data.agency_id,
                        fetchTables: [
                            'agencies_address',
                            'agencies_phone',
                            'agencies_payment',
                        ],
                    },
                    randomVariable
                )
            } else if (
                responseStatusAgency?.from === 'addressupdate' ||
                responseStatusAgency?.from === 'phoneupdate' ||
                responseStatusAgency?.from === 'defaultupdate' ||
                responseStatusAgency?.from === 'paymentupdate' ||
                responseStatusAgency?.from === 'deleteupdate'
            ) {
                randomVariable = Math.random()
                getSingleAgency(
                    {
                        id: props.agencyId,
                        fetchTables: [
                            'agencies_address',
                            'agencies_phone',
                            'agencies_payment',
                        ],
                    },
                    randomVariable
                )
                resetFormikValues(addressFormik)
                resetFormikValues(paymentFormik)
                resetFormikValues(phoneFormik)
            }
            setIsLoading(false)
            // updateConfigColumn(null, true)
        }
        setAddressDisable(false)
    }, [responseStatusAgency])

    const addressValidation = Yup.object({
        agency_id: Yup.string()
            .trim()
            .matches(/^[0-9- +()]*$/g, 'Only numbers are allowed')
            .required('Required!'),
        facility_name: Yup.string().required('Required!'),
        address_line_1: Yup.string().required('Required!'),
        address_line_2: Yup.string().nullable(),
        country: Yup.string().required('Required!'),
        state: Yup.string().required('Required!'),
        county: Yup.string().required('Required!').nullable(),
        city: Yup.string()
            .trim()
            .matches(/^[0-9a-zA-Z ]*$/g, 'The characters only')
            .required('Required'),
        zip: Yup.string()
            .trim()
            .matches(/^[0-9]*$/g, 'Only numbers are allowed')
            .min(5, 'Mininum 5 digits')
            .max(6, 'Maximum 6 digits')
            .required('Required!')
            .nullable(),
    })

    const addressFormik = useFormik({
        initialValues: {
            page: 1,
            limit: 5,
            order: '',
            orderby: '',
            table: 'agencies_address',
            id: 0,
            agency_id: props.agencyId ? props.agencyId : 0,
            facility_name: '',
            address_line_1: '',
            address_line_2: '',
            country: global.defaultCountry,
            state: global.defaultState,
            county: '',
            city: '',
            zip: '',
            state_tax: 0,
            city_tax: 0,
            county_tax: 0,
            county_transit_sales_use_tax: 0,
            metro_transportation_tax: 0,
            metro_sale_use_for_housing: 0,
            transit_tax: 0,
            vehicle_tax: 0,
            auto_excise_tax: 0,
        },
        validationSchema: addressValidation,
        onSubmit: (values) => {
            values.agency_id = props.agencyId || 0
            setAddressDisable(true)
            agencyAction(values, 'addressupdate')
            handleEditPopup('address')
            // setIsLoading(true)
        },
    })

    const agencyAddressFields = [
        {
            label: 'Facility Name',
            type: 'text',
            placeholder: 'Enter facility name',
            class: 'col-sm-6 col-12',
            name: 'facility_name',
        },
        {
            label: 'Address Line 1',
            type: 'text',
            placeholder: 'Enter address line 1',
            class: 'col-sm-6 col-12',
            name: 'address_line_1',
        },
        {
            label: 'Address Line 2',
            type: 'text',
            placeholder: 'Enter address line 2',
            class: 'col-sm-6 col-12',
            name: 'address_line_2',
        },
        {
            label: 'Country',
            type: 'select',
            placeholder: 'Select a Country',
            class: 'col-sm-6 col-12',
            disabled: true,
            options: allCountries
                .filter(
                    (country) =>
                        global.ignoreCountry.indexOf(country.isoCode) === -1
                )
                .map((country) => {
                    let busCategoryChanged = {}
                    busCategoryChanged.show = country.name
                    busCategoryChanged.value = country.isoCode
                    return busCategoryChanged
                }),
            name: 'country',
        },
        {
            label: 'State',
            type: 'select',
            placeholder: 'Select a State',
            class: 'col-sm-6 col-12',
            disabled: true,
            options: allStates
                .filter(
                    (state) =>
                        (addressFormik.values.country
                            ? addressFormik.values.country.indexOf(
                                  state.countryCode
                              ) !== -1
                            : global.defaultCountry.indexOf(
                                  state.countryCode
                              ) !== -1) &&
                        global.ignoreStates.indexOf(state.isoCode) === -1
                )
                .map((buscat) => {
                    let busCategoryChanged = {}
                    busCategoryChanged.show = buscat.name
                    busCategoryChanged.value = buscat.isoCode
                    return busCategoryChanged
                }),
            name: 'state',
        },
        {
            label: 'County',
            type: 'select',
            placeholder: 'Select a County',
            class: 'col-sm-6 col-12',
            options: allCountiesDropdown
                .filter((state) =>
                    addressFormik.values.state
                        ? addressFormik.values.state === state.state_code
                        : []
                )
                .map((buscat) => {
                    let busCategoryChanged = {}
                    busCategoryChanged.show = buscat.county
                    busCategoryChanged.value = buscat.county
                    return busCategoryChanged
                }),

            name: 'county',
        },
        {
            label: 'City',
            type: 'select',
            placeholder: 'Select a City',
            class: 'col-sm-6 col-12',
            options: addressFormik.values.county
                ? allCitiesDropdown
                      .filter(
                          (county) =>
                              addressFormik.values.county === county.county
                      )
                      .map((buscat) => {
                          let busCategoryChanged = {}
                          busCategoryChanged.show = buscat.city
                          busCategoryChanged.value = buscat.city
                          return busCategoryChanged
                      })
                : [],
            name: 'city',
        },
        {
            label: 'Zip Code',
            type: 'select',
            placeholder: 'Enter zip code',
            class: 'col-sm-6 col-12',
            options: addressFormik.values.city
                ? taxTable
                      .filter(
                          (data) =>
                              addressFormik.values.county === data.county &&
                              addressFormik.values.city === data.city
                      )
                      .map((buscat) => {
                          let busCategoryChanged = {}
                          busCategoryChanged.show = buscat.zip
                          busCategoryChanged.value = buscat.zip
                          return busCategoryChanged
                      })
                : [],
            name: 'zip',
        },
        {
            label: 'State Tax (%)',
            type: 'text',
            placeholder: '',
            class: 'col-sm-6 col-12',
            name: 'state_tax',
            disabled: true,
        },
        {
            label: 'County Tax (%)',
            type: 'text',
            placeholder: '',
            class: 'col-sm-6 col-12',
            name: 'county_tax',
            disabled: true,
        },
        {
            label: 'City Tax (%)',
            type: 'text',
            placeholder: '',
            class: 'col-sm-6 col-12',
            name: 'city_tax',
            disabled: true,
        },
        {
            label: 'County Transit Sales & Use Tax (%)',
            type: 'text',
            name: 'county_transit_sales_use_tax',
            placeholder: '',
            class: 'col-sm-6 col-12',
            disabled: true,
        },
        {
            label: 'Metro Transportation Tax (%)',
            type: 'text',
            name: 'metro_transportation_tax',
            placeholder: '',
            class: 'col-sm-6 col-12',
            disabled: true,
        },
        {
            label: 'Metro Sale & Use for Housing Tax (%)',
            type: 'text',
            name: 'metro_sale_use_for_housing',
            placeholder: '',
            class: 'col-sm-6 col-12',
            disabled: true,
        },
        {
            label: 'Transit Tax (%)',
            type: 'text',
            name: 'transit_tax',
            placeholder: '',
            class: 'col-sm-6 col-12',
            disabled: true,
        },
        {
            label: 'Vehicle Tax (Amount)',
            type: 'text',
            name: 'vehicle_tax',
            placeholder: '',
            class: 'col-sm-6 col-12',
            disabled: true,
        },
        {
            label: 'Auto Excise Tax (Amount)',
            type: 'text',
            name: 'auto_excise_tax',
            placeholder: '',
            class: 'col-sm-6 col-12',
            disabled: true,
        },
    ]

    useEffect(() => {
        if (addressFormik?.values?.zip) {
            let taxData = taxTable.find(
                (data) => data.zip === addressFormik.values.zip
            )
            if (taxData) {
                addressFormik.setFieldValue('state_tax', taxData.state_tax)
                addressFormik.setFieldValue('county_tax', taxData.county_tax)
                addressFormik.setFieldValue('city_tax', taxData.city_tax)
                addressFormik.setFieldValue(
                    'county_transit_sales_use_tax',
                    taxData.county_transit_sales_use_tax
                )
                addressFormik.setFieldValue(
                    'metro_transportation_tax',
                    taxData.metro_transportation_tax
                )
                addressFormik.setFieldValue(
                    'metro_sale_use_for_housing',
                    taxData.metro_sale_use_for_housing
                )
                addressFormik.setFieldValue('transit_tax', taxData.transit_tax)
                addressFormik.setFieldValue('vehicle_tax', taxData.vehicle_tax)
                addressFormik.setFieldValue(
                    'auto_excise_tax',
                    taxData.auto_excise_tax
                )
            }
        }

        // chnage to decimal
        Object.keys(addressFormik?.values).map((buscat) => {
            if (acceptedDecimalFields.includes(buscat)) {
                let decimalValue = parseFloat(
                    addressFormik.values[buscat] || 0
                ).toFixed(3)
                addressFormik.values[buscat] = decimalValue
            }
        })
    }, [addressFormik?.values])

    const phoneValidation = Yup.object({
        agency_id: Yup.string()
            .trim()
            .matches(/^[0-9- +()]*$/g, 'Only numbers are allowed')
            .required('Required!'),
        phone_type: Yup.string().required('Required!'),
        phone: Yup.string()
            .trim()
            .matches(/^[0-9- +()]*$/g, 'Only numbers are allowed')
            .min(15, 'Please enter correct phone number')
            .required('Required!'),
        phone_ext: Yup.string().nullable(),
    })

    const phoneFormik = useFormik({
        initialValues: {
            page: 1,
            limit: 5,
            order: '',
            orderby: '',
            table: 'agencies_phone',
            id: 0,
            agency_id: props.agencyId ? props.agencyId : 0,
            phone_type: '',
            phone: '',
            phone_ext: '',
        },
        validationSchema: phoneValidation,
        onSubmit: (values) => {
            values.agency_id = props.agencyId || 0
            setAddressDisable(true)
            agencyAction(values, 'phoneupdate')
            handleEditPopup('phone')
            setIsLoading(true)
        },
    })

    //Payment

    const agencyPhoneFields = [
        {
            label: 'Phone Type',
            type: 'select',
            placeholder: 'Select phone type',
            class: 'col-6 col-12',
            options: phoneTypes,
            name: 'phone_type',
        },
        {
            label: 'Phone Number',
            type: 'phone',
            placeholder: 'Enter phone number',
            class: 'col-6 col-12',
            name: 'phone',
            countryCodeEditable: false,
        },
        {
            label: 'Extension Code',
            type: 'text',
            placeholder: 'Enter extension code',
            class: 'col-6 col-12',
            name: 'phone_ext',
        },
    ]

    let paymentValidation = {
        acc_num: Yup.string(),
        fin_id: Yup.string(),
        funds: Yup.string(),
        approp: Yup.string(),
        pc_bus: Yup.string(),
        project_type: Yup.string(),
        src_type: Yup.string(),
        vendor_id: Yup.string(),
        notes: Yup.string(),
        activity: Yup.string(),
    }
    if (agencyType === '1') {
        paymentValidation = {
            acc_num: Yup.string().required('Required!'),
            fin_id: Yup.string().required('Required!'),
            funds: Yup.string().required('Required!'),
            approp: Yup.string().required('Required!'),
            pc_bus: Yup.string(),
            project_type: Yup.string(),
            src_type: Yup.string(),
            vendor_id: Yup.string(),
            notes: Yup.string(),
            activity: Yup.string(),
        }
    } else if (agencyType === '2') {
        paymentValidation = {
            acc_num: Yup.string(),
            fin_id: Yup.string(),
            funds: Yup.string(),
            approp: Yup.string(),
            pc_bus: Yup.string(),
            project_type: Yup.string(),
            src_type: Yup.string(),
            vendor_id: Yup.string().required('Required!'),
            notes: Yup.string(),
            activity: Yup.string(),
        }
    }

    const paymentFormik = useFormik({
        initialValues: {
            table: 'agencies_payment',
            page: 1,
            limit: 5,
            order: '',
            orderby: '',
            id: 0,
            agency_id: props.agencyId ? props.agencyId : 0,
            acc_num: '',
            fin_id: '',
            funds: '',
            approp: '',
            pc_bus: '',
            project_type: '',
            src_type: '',
            vendor_id: '',
            acivity: '',
            notes: '',
        },
        validationSchema: Yup.object(paymentValidation),
        onSubmit: (values) => {
            values.agency_id = props.agencyId || 0
            setAddressDisable(true)
            agencyAction(values, 'paymentupdate')
            handleEditPopup('payment')
            setIsLoading(true)
        },
    })

    const paymentFields = [
        {
            label: 'Account Number',
            type: 'text',
            placeholder: 'Enter Account Number',
            class: `col-sm-6 col-12`,
            // autoFocus: true,
            name: 'acc_num',
        },
        {
            label: 'Financial Dept. ID',
            type: 'text',
            placeholder: 'Enter Financial Dept. ID',
            class: `col-sm-6 col-12`,
            name: 'fin_id',
        },
        {
            label: 'Funds',
            type: 'text',
            placeholder: 'Enter Funds',
            class: `col-sm-6 col-12`,
            name: 'funds',
        },
        {
            label: 'Approp',
            type: 'text',
            placeholder: 'Enter Approp',
            class: `col-sm-6 col-12`,
            name: 'approp',
        },
        {
            label: 'PC Bus',
            type: 'text',
            placeholder: 'Enter PC Bus',
            class: 'col-sm-6 col-12',
            name: 'pc_bus',
        },
        {
            label: 'Project',
            placeholder: 'Enter Project',
            type: 'text',
            class: 'col-sm-6 col-12',
            name: 'project_type',
        },
        {
            label: 'Activity',
            type: 'text',
            placeholder: 'Enter Activity',
            class: 'col-sm-6 col-12',
            name: 'acivity',
        },
        {
            label: 'Src Type',
            type: 'text',
            placeholder: 'Enter Src Type',
            class: 'col-sm-6 col-12',
            name: 'src_type',
        },
        {
            label: 'Vendor #',
            type: 'text',
            placeholder: 'Enter Vendor #',
            class: 'col-sm-6 col-12',
            name: 'vendor_id',
        },
        {
            label: 'Notes',
            type: 'text',
            placeholder: 'Enter Notes',
            class: 'col-sm-6 col-12',
            name: 'notes',
        },
    ]

    const resetFields = (field) => {
        if (field === 'address') {
            addressFormik.values.page = 1
            addressFormik.values.limit = 5
            addressFormik.values.order = ''
            addressFormik.values.orderby = ''
            addressFormik.values.table = 'agencies_address'
            addressFormik.values.id = 0
            addressFormik.values.agency_id = props.agencyId ? props.agencyId : 0
            addressFormik.values.facility_name = ''
            addressFormik.values.address_line_1 = ''
            addressFormik.values.address_line_2 = ''
            addressFormik.values.country = global.defaultCountry
            addressFormik.values.state = global.defaultState
            addressFormik.values.city = ''
            addressFormik.values.zip = ''
            addressFormik.values.county = ''
            addressFormik.values.state_tax = 0
            addressFormik.values.city_tax = 0
            addressFormik.values.county_tax = 0
            addressFormik.values.county_transit_sales_use_tax = 0
            addressFormik.values.metro_transportation_tax = 0
            addressFormik.values.metro_sale_use_for_housing = 0
            addressFormik.values.transit_tax = 0
            addressFormik.values.vehicle_tax = 0
            addressFormik.values.auto_excise_tax = 0
        }
        if (field === 'phone') {
            phoneFormik.values.page = 1
            phoneFormik.values.limit = 5
            phoneFormik.values.order = ''
            phoneFormik.values.orderby = ''
            phoneFormik.values.table = 'agencies_phone'
            phoneFormik.values.id = 0
            phoneFormik.values.agency_id = props.agencyId ? props.agencyId : 0
            phoneFormik.values.phone_type = ''
            phoneFormik.values.phone = ''
            phoneFormik.values.phone_ext = ''
        }
        if (field === 'payment') {
            paymentFormik.values.page = 1
            paymentFormik.values.limit = 5
            paymentFormik.values.order = ''
            paymentFormik.values.orderby = ''
            paymentFormik.values.table = 'agencies_payment'
            paymentFormik.values.id = 0
            paymentFormik.values.agency_id = props.agencyId ? props.agencyId : 0
            paymentFormik.values.phone_type = ''
            paymentFormik.values.phone = ''
            paymentFormik.values.phone_ext = ''
        }
        setReload(!reload)
    }

    const handleEditPopup = (data) => {
        resetFields(data)
        if (data === 'address') {
            setAddressPopup(false)
        }
        if (data === 'phone') {
            setPhonePopup(false)
        }

        if (data === 'payment') {
            setPaymentModal(false)
        }
    }

    const handleNewPopup = (data) => {
        resetFields(data)
        if (data === 'address') {
            setAddressPopup(true)
            resetFormikValues(addressFormik)
        }
        if (data === 'phone') {
            setPhonePopup(true)
            resetFormikValues(phoneFormik)
        }

        if (data === 'payment') {
            resetFormikValues(paymentFormik)
            setPaymentModal(true)
        }
    }

    //PHONE

    const onAgencyPhoneEdit = (id) => {
        let editData = single_agency?.record?.agencies_phone?.filter(
            (d) => d.id == id
        )[0]

        Object.keys(editData).map((buscat) => {
            phoneFormik.setFieldValue(buscat, editData[buscat])
            // phoneFormik.values[buscat] = editData[buscat]
        })
        phoneFormik.values.table = 'agencies_phone'
        setPhonePopup(true)
    }

    const onAgencyPhoneDelete = (id) => {
        let payload = {
            table: 'agencies_phone',
            id: id,
            deleteEntry: true,
        }
        setIsLoading(true)
        agencyAction(payload, 'deleteupdate')
    }

    const onAgencyPhoneDefault = (id, agencyId) => {
        let payload = {
            action: 'setDefault',
            table: 'agencies_phone',
            id: id,
            agency_id: agencyId,
        }
        setIsLoading(true)
        agencyAction(payload, 'defaultupdate')
    }

    const getMultiplePhoneActions = () => {
        let actionPush = [
            {
                buttonType: 'edit',
                clickType: 'edit',
                onclick: onAgencyPhoneEdit,
                tooltipTitle: 'Edit Phone Number',
            },
            {
                buttonType: 'delete',
                clickType: 'delete',
                onclick: onAgencyPhoneDelete,
                tooltipTitle: 'Delete Phone Number',
            },
            {
                buttonType: 'check_circle',
                clickType: '',
                onclick: onAgencyPhoneDefault,
                disabledField: 'is_default',
                disabledType: true,
                tooltipTitle: 'Make Default',
            },
        ]
        return actionPush
    }

    const agencyPhoneTableValues = [
        {
            field: 'phone_type',
            type: 'removeUnderscores',
            sort: true,
            filterable: true,
            firstChild: true,
            label: 'Phone Type',
        },
        {
            field: 'phone',
            sort: true,
            filterable: true,
            type: '',
            label: 'Phone Number',
        },

        {
            field: 'phone_ext',
            type: '',
            sort: true,
            filterable: true,
            label: 'Extension Code',
        },
        {
            field: 'is_default',
            type: 'boolean',
            label: 'Default',
        },
        {
            field: 'action',
            type: 'button',
            clickID: 'id',
            secondaryClickID: 'agency_id',
            sort: false,
            filterable: false,
            firstChild: false,
            disablePadding: false,
            label: 'Action',
            isMultiple: getMultiplePhoneActions(),
        },
    ]

    //ADDRESS

    const onAgencyAddressEdit = (id) => {
        let editData = single_agency?.record?.agencies_address?.filter(
            (d) => d.id == id
        )[0]

        Object.keys(editData).map((buscat) => {
            addressFormik.setFieldValue(buscat, editData[buscat])
            // addressFormik.values[buscat] = editData[buscat]
            if (acceptedDecimalFields.includes(buscat)) {
                let decimalValue = parseFloat(
                    addressFormik.values[buscat]
                ).toFixed(3)
                // addressFormik.values[buscat] = decimalValue
                addressFormik.setFieldValue(buscat, decimalValue)
            }
        })
        addressFormik.values.table = 'agencies_address'
        setAddressPopup(true)
    }

    const onAgencyAddressDelete = (id) => {
        let payload = {
            table: 'agencies_address',
            id: id,
            deleteEntry: true,
        }
        setIsLoading(true)
        agencyAction(payload, 'deleteupdate')
    }

    const onAgencyAddressDefault = (id, agencyId) => {
        let payload = {
            action: 'setDefault',
            table: 'agencies_address',
            id: id,
            agency_id: agencyId,
        }
        setIsLoading(true)
        agencyAction(payload, 'defaultupdate')
    }

    const getMultipleAddressActions = () => {
        let actionPush = [
            {
                buttonType: 'edit',
                clickType: 'edit',
                onclick: onAgencyAddressEdit,
                tooltipTitle: 'Edit Address Number',
            },
            {
                buttonType: 'delete',
                clickType: 'delete',
                onclick: onAgencyAddressDelete,
                tooltipTitle: 'Delete Address Number',
            },
            {
                buttonType: 'check_circle',
                clickType: '',
                onclick: onAgencyAddressDefault,
                disabledField: 'is_default',
                disabledType: true,
                tooltipTitle: 'Make Default',
            },
        ]
        return actionPush
    }

    const agencyAddressTableValues = [
        {
            field: 'facility_name',
            type: '',
            sort: true,
            firstChild: true,
            filterable: true,
            label: 'Facility Name',
        },
        {
            field: 'address_line_1',
            type: '',
            sort: true,
            filterable: true,
            label: 'Address',
        },
        {
            field: 'country',
            type: '',
            sort: true,
            filterable: true,
            label: 'Country',
        },
        {
            field: 'state',
            type: '',
            sort: true,
            filterable: true,
            label: 'State',
        },
        {
            field: 'county',
            type: '',
            sort: true,
            filterable: true,
            label: 'County',
        },
        {
            field: 'city',
            type: '',
            sort: true,
            filterable: true,
            label: 'City',
        },
        {
            field: 'zip',
            type: '',
            sort: true,
            filterable: true,
            label: 'Zip',
        },
        {
            field: 'is_default',
            type: 'boolean',
            label: 'Default',
        },
        {
            field: 'action',
            type: 'button',
            clickID: 'id',
            secondaryClickID: 'agency_id',
            sort: false,
            filterable: false,
            firstChild: false,
            disablePadding: false,
            label: 'Action',
            isMultiple: getMultipleAddressActions(),
        },
    ]

    //FUNDING STREAM

    const onAgencyPaymentEdit = (id) => {
        let editData = single_agency?.record?.agencies_payment?.filter(
            (d) => d.id == id
        )[0]

        Object.keys(editData).map((buscat) => {
            if (buscat === 'notes') {
                editData[buscat] = editData[buscat] || ''
            }
            // paymentFormik.values[buscat] = editData[buscat]
            paymentFormik.setFieldValue(buscat, editData[buscat])
        })
        paymentFormik.values.table = 'agencies_payment'
        setPaymentModal(true)
    }

    const onAgencyPaymentDelete = (id) => {
        let payload = {
            table: 'agencies_payment',
            id: id,
            deleteEntry: true,
        }
        setIsLoading(true)
        agencyAction(payload, 'deleteupdate')
    }

    const onAgencyPaymentDefault = (id, agencyId) => {
        let payload = {
            action: 'setDefault',
            table: 'agencies_payment',
            id: id,
            agency_id: agencyId,
        }
        setIsLoading(true)
        agencyAction(payload, 'defaultupdate')
    }

    const getMultiplePaymentActions = () => {
        let actionPush = [
            {
                buttonType: 'edit',
                clickType: 'edit',
                onclick: onAgencyPaymentEdit,
                tooltipTitle: 'Edit Funding Stream',
            },
            {
                buttonType: 'delete',
                clickType: 'delete',
                onclick: onAgencyPaymentDelete,
                tooltipTitle: 'Delete Funding Stream',
            },
            {
                buttonType: 'check_circle',
                clickType: '',
                onclick: onAgencyPaymentDefault,
                disabledField: 'is_default',
                disabledType: true,
                tooltipTitle: 'Make Default',
            },
        ]
        return actionPush
    }

    const agencyPaymentTableValues = [
        {
            field: 'acc_num',
            type: '',
            sort: true,
            firstChild: true,
            filterable: true,
            label: 'Account Number',
        },
        {
            field: 'fin_id',
            type: '',
            sort: true,
            filterable: true,
            label: 'Financial Dept. ID',
        },
        {
            field: 'funds',
            sort: true,
            filterable: true,
            type: '',
            label: 'Funds',
        },
        {
            field: 'approp',
            sort: true,
            filterable: true,
            type: '',
            label: 'Approp',
        },
        {
            field: 'pc_bus',
            sort: true,
            sort: true,
            filterable: true,
            type: '',
            label: 'PC Bus',
        },
        {
            field: 'project_type',
            sort: true,
            filterable: true,
            type: '',
            label: 'Project',
        },
        {
            field: 'acivity',
            sort: true,
            filterable: true,
            type: '',
            label: 'Activity',
        },

        {
            field: 'src_type',
            sort: true,
            filterable: true,
            type: '',
            label: 'Src Type',
        },
        {
            field: 'vendor_id',
            sort: true,
            filterable: true,
            type: '',
            label: 'Vendor #',
        },
        {
            field: 'notes',
            sort: true,
            filterable: true,
            type: '',
            label: 'Notes',
        },
        {
            field: 'is_default',
            type: 'boolean',
            label: 'Default',
        },
        {
            field: 'action',
            type: 'button',
            clickID: 'id',
            secondaryClickID: 'agency_id',
            sort: false,
            filterable: false,
            firstChild: false,
            disablePadding: false,
            label: 'Action',
            isMultiple: getMultiplePaymentActions(),
        },
    ]

    return (
        <div className="addUserModal">
            <div className="fspBody">
                {/* {formik.isSubmitting ? <LinearProgress /> : null} */}
                {isLoading ? (
                    <div className="fspLoader">
                        <Loaders isLoading={isLoading} />
                    </div>
                ) : (
                    <>
                        <form
                            onSubmit={formik.handleSubmit}
                            autoComplete="nofill"
                        >
                            <h2 className="dashTitle">Basic Information</h2>
                            <div className="row">
                                {mapData({
                                    formik: formik,
                                    data: props.agencyBasicDetails,
                                })}
                            </div>
                            <div className="actionButton d-flex justify-content-end align-items-left flex-wrap">
                                <SecondaryButton
                                    id="agency_reset"
                                    label="RESET"
                                    onClick={() => resetFrom()}
                                />
                                <PrimaryButton
                                    id="agency_submit"
                                    type="submit"
                                    label="SAVE"
                                />
                            </div>
                        </form>
                        {props.agencyId ? (
                            <>
                                <div className="agencyAddnDetails">
                                    {agencyAddress.length > 0 ? (
                                        <>
                                            <div className="agencyMiscTitle">
                                                <h3>Agency Address(es)</h3>
                                            </div>
                                            <CustomTable
                                                formik={{
                                                    ...addressFormik.values,
                                                    id: props?.agencyId,
                                                    fetchTables: [
                                                        'agencies_address',
                                                    ],
                                                }}
                                                filterMode="client"
                                                paginationMode="client"
                                                sortingMode="client"
                                                tableBody={agencyAddress}
                                                tableValues={
                                                    agencyAddressTableValues
                                                }
                                                tableActions={[]}
                                                allData={{
                                                    ...single_agency?.record
                                                        ?.agencies_address,
                                                    totalRecords:
                                                        single_agency?.record
                                                            ?.agencies_address
                                                            ?.length,
                                                }}
                                                isLoading={isLoading}
                                                loadingTemplate={'table'}
                                                changeTableFunction={
                                                    getSingleAgency
                                                }
                                                customToolbarButton={{
                                                    function: () =>
                                                        handleNewPopup(
                                                            'address',
                                                            true
                                                        ),
                                                    label: 'Add New',
                                                    icon: 'add',
                                                }}
                                                columnStorageVariable={
                                                    'table_agency_index_address'
                                                }
                                            />
                                        </>
                                    ) : (
                                        <Button
                                            className="addIntitialState"
                                            onClick={() =>
                                                handleNewPopup('address', true)
                                            }
                                        >
                                            <span className="material-icons-outlined">
                                                add_circle_outline
                                            </span>
                                            Add a new Address
                                        </Button>
                                    )}
                                </div>

                                <div className="agencyAddnDetails">
                                    {agencyPhone.length > 0 ? (
                                        <>
                                            <div className="agencyMiscTitle">
                                                <h3>Agency Phone(s)</h3>
                                            </div>
                                            <CustomTable
                                                formik={{
                                                    ...phoneFormik.values,
                                                    id: props?.agencyId,
                                                    fetchTables: [
                                                        'agencies_phone',
                                                    ],
                                                }}
                                                filterMode="client"
                                                paginationMode="client"
                                                sortingMode="client"
                                                tableBody={agencyPhone}
                                                tableValues={
                                                    agencyPhoneTableValues
                                                }
                                                tableActions={[]}
                                                allData={{
                                                    ...single_agency?.record
                                                        ?.agencies_phone,
                                                    totalRecords:
                                                        single_agency?.record
                                                            ?.agencies_phone
                                                            ?.length,
                                                }}
                                                isLoading={isLoading}
                                                loadingTemplate={'table'}
                                                changeTableFunction={
                                                    getSingleAgency
                                                }
                                                customToolbarButton={{
                                                    function: () =>
                                                        handleNewPopup(
                                                            'phone',
                                                            true
                                                        ),
                                                    label: 'Add New',
                                                    icon: 'add',
                                                }}
                                                columnStorageVariable={
                                                    'table_agency_index_phone'
                                                }
                                            />
                                        </>
                                    ) : (
                                        <Button
                                            className="addIntitialState"
                                            onClick={() =>
                                                handleNewPopup('phone', true)
                                            }
                                        >
                                            <span className="material-icons-outlined">
                                                add_circle_outline
                                            </span>
                                            Add a new Phone Number
                                        </Button>
                                    )}
                                </div>

                                <div className="agencyAddnDetails">
                                    {paymentMethod.length > 0 ? (
                                        <>
                                            <div className="agencyMiscTitle">
                                                <h3>Agency Account(s)</h3>
                                            </div>

                                            <CustomTable
                                                formik={{
                                                    ...paymentFormik.values,
                                                    id: props?.agencyId,
                                                    fetchTables: [
                                                        'agencies_payment',
                                                    ],
                                                }}
                                                filterMode="client"
                                                paginationMode="client"
                                                sortingMode="client"
                                                tableBody={paymentMethod}
                                                tableValues={
                                                    agencyPaymentTableValues
                                                }
                                                tableActions={[]}
                                                allData={{
                                                    ...single_agency?.record
                                                        ?.agencies_payment,
                                                    totalRecords:
                                                        single_agency?.record
                                                            ?.agencies_payment
                                                            ?.length,
                                                }}
                                                isLoading={isLoading}
                                                loadingTemplate={'table'}
                                                changeTableFunction={
                                                    getSingleAgency
                                                }
                                                customToolbarButton={{
                                                    function: () =>
                                                        handleNewPopup(
                                                            'payment',
                                                            true
                                                        ),
                                                    label: 'Add New',
                                                    icon: 'add',
                                                }}
                                                columnStorageVariable={
                                                    'table_agency_index_payment'
                                                }
                                            />
                                        </>
                                    ) : (
                                        <Button
                                            className="addIntitialState"
                                            onClick={() =>
                                                handleNewPopup('payment', true)
                                            }
                                        >
                                            <span className="material-icons-outlined">
                                                add_circle_outline
                                            </span>
                                            Add a new Payment Method
                                        </Button>
                                    )}
                                </div>
                            </>
                        ) : null}
                    </>
                )}
            </div>
            <CustomDialog
                title="Add a Agency Address"
                className="agencyMiscModal"
                open={addressPopup}
                function={() => handleEditPopup('address')}
                TransitionComponent={Transition}
            >
                <div>
                    <form>
                        <div className="row">
                            {mapData({
                                formik: addressFormik,
                                data: agencyAddressFields,
                            })}
                        </div>
                        <div className="modalActBtn">
                            <SecondaryButton
                                label="Cancel"
                                onClick={() => {
                                    handleEditPopup('address')
                                }}
                            />
                            <PrimaryButton
                                btnSize="ml-2"
                                label={
                                    addressFormik?.values?.id ? 'Update' : 'Add'
                                }
                                disabled={addressDisable}
                                onClick={addressFormik.handleSubmit}
                            />
                        </div>
                    </form>
                </div>
            </CustomDialog>
            <CustomDialog
                title="Add a Agency Phone"
                className="agencyMiscModal"
                open={phonePopup}
                function={() => handleEditPopup('phone')}
                TransitionComponent={Transition}
            >
                <div>
                    <form>
                        <div className="row">
                            {mapData({
                                formik: phoneFormik,
                                data: agencyPhoneFields,
                            })}
                        </div>
                        <div className="modalActBtn">
                            <SecondaryButton
                                label="Cancel"
                                onClick={() => {
                                    handleEditPopup('phone')
                                }}
                            />
                            <PrimaryButton
                                btnSize="ml-2"
                                label={
                                    phoneFormik?.values?.id ? 'Update' : 'Add'
                                }
                                disabled={addressDisable}
                                onClick={phoneFormik.handleSubmit}
                            />
                        </div>
                    </form>
                </div>
            </CustomDialog>
            <CustomDialog
                title="Add a Payment Method"
                className="agencyMiscModal"
                open={paymentModal}
                function={() => handleEditPopup('payment')}
                TransitionComponent={Transition}
            >
                <div>
                    <form>
                        <div className="row">
                            {mapData({
                                formik: paymentFormik,
                                data: paymentFields,
                            })}
                        </div>
                        <div className="modalActBtn">
                            <SecondaryButton
                                label="Cancel"
                                onClick={() => {
                                    handleEditPopup('payment')
                                }}
                            />
                            <PrimaryButton
                                btnSize="ml-2"
                                label={
                                    paymentFormik?.values?.id ? 'Update' : 'Add'
                                }
                                disabled={addressDisable}
                                onClick={paymentFormik.handleSubmit}
                            />
                        </div>
                    </form>
                </div>
            </CustomDialog>
        </div>
    )
}

export default AgencyForm
